import type { AddressStored, CasAddress } from "@jti/fe-common";

export const convertFormAddress = (address: AddressStored): CasAddress & { id: string } => {
  return {
    id: address.id ?? "",
    country_code: address.countryCode,
    street: [address.streetName, address.streetNumber, address.streetAdditional],
    phone: address.telephone,
    post_code: address.postcode,
    city: address.city,
    first_name: address.firstname,
    last_name: address.lastname,
    default_shipping: address.isDefaultShipping ?? false,
    default_billing: address.isDefaultBilling ?? false,
    administrative_area_level_2: address.provinceName || "",
    sublocality_level_2: address.districtName || "",
    district: address.district || "",
    building_number: address.buildingNumber || "",
    neighborhood: address.neighborhood || "",
    landmark: address.landmark || "",
    premise: address.premise || "",
    short_address: address.shortAddress || "",
    ...(address.region && {
      region: address.region,
    }),
  };
};
